import React, {FunctionComponent, useCallback, useEffect, useRef} from 'react'
import {useNavigation, useRootDispatch, useRootSelector} from '../../../utils/hooks'
import refStyles from '../settings/RefPage/RefPage.module.sass'
import {Table} from '../../data-components/Table/Table/Table'
import {ContactsUser} from '../../../responses/users'
import {Align, Column} from '../../data-components/Table/Column'
import Field from '../../controls/Field/Field'
import SearchIcon from 'files/search.svg'
import {contactsActions} from '../../../redux/pages/contacts/users'
import clsx from 'clsx'
import styles from './ContactsPage.module.sass'


const ContactsDesktop: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const search = useRootSelector(state => state.pages.contacts.search)
    const data = useRootSelector(state => state.pages.contacts.data)

    const setSearch = useCallback((search: string) => {
        dispatch(contactsActions.list.init(search))
    }, [dispatch])

    useEffect(() => {
        setSearch(search)
    }, [setSearch, search])

    const listRef = useRef(null)
    useNavigation(listRef)


    return <div className={refStyles.refPage}>
        <div className={refStyles.header}>
            <Field placeholder={'Поиск'} rightItem={<SearchIcon/>} value={search} onChange={setSearch}/>
        </div>
        <Table<ContactsUser>
            className={clsx(refStyles.table, styles.table)}
            data={data}
        >
            <Column<ContactsUser> headerRenderer={'Имя'} cellRenderer={user => user.name}/>
            <Column<ContactsUser> columnAlign={Align.CENTER} headerRenderer={'Телефон'}
                                  cellRenderer={user => {
                                      let phone = user.phone
                                      phone = phone.replace('(', ' (')
                                      phone = phone.replace(')', ') ')
                                      return phone
                                  }}/>
            <Column<ContactsUser> columnAlign={Align.CENTER} headerRenderer={'Скайп'}
                                  cellRenderer={user => user.skype}/>
            <Column<ContactsUser> columnAlign={Align.CENTER} headerRenderer={'E-mail'}
                                  cellRenderer={user => user.email}/>
            <Column<ContactsUser> columnAlign={Align.CENTER}
                                  headerRenderer={'Направления'}
                                  cellRenderer={user => user.directions.map(dep => dep).join(', ')}
            />
            <Column<ContactsUser> columnAlign={Align.CENTER}
                                  headerRenderer={'Отделы'}
                                  cellRenderer={user => user.departments.map(dep => dep).join(', ')}
            />
            <Column<ContactsUser> columnAlign={Align.CENTER}
                                  headerRenderer={'Должность'}
                                  cellRenderer={user => user.position}
            />
        </Table>
    </div>
}

export default ContactsDesktop
